import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

export const VehicleSavingLoader = ({ visible }) => {
  const { t } = useTranslation();
  const [dots, setDots] = useState("");

  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 400);
    return () => clearInterval(interval);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-md transition-all">
      <div className="bg-[#0B0E39] text-white p-7 sm:p-8 rounded-3xl shadow-2xl flex flex-col items-center max-w-sm w-full mx-4 border border-white/10 animate-in fade-in zoom-in-95 duration-200">
        {/* Animated Icon Ring */}
        <div className="relative w-16 h-16 flex items-center justify-center mb-6">
          <div className="absolute inset-0 rounded-full border-2 border-emerald-500/20 animate-ping" />
          <div className="w-14 h-14 rounded-full bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center">
            <Loader2 className="w-7 h-7 text-[#3BD97A] animate-spin stroke-[2.2]" />
          </div>
        </div>

        {/* Indeterminate Gradient Progress Bar */}
        <div className="w-48 h-1.5 bg-white/10 rounded-full overflow-hidden mb-5 relative">
          <div className="absolute inset-y-0 w-24 bg-gradient-to-r from-transparent via-[#3BD97A] to-transparent rounded-full animate-[progress_1.4s_ease-in-out_infinite]" />
        </div>

        <h3 className="text-base sm:text-lg font-bold text-white tracking-tight text-center">
          {t("profile.savingVehicle") || "Saving your vehicle…"}
        </h3>
        <p className="text-xs text-white/60 text-center mt-1 font-medium min-h-[18px]">
          {t("profile.uploadingPhotos") || "Uploading photos, please wait"}
          {dots}
        </p>
      </div>

      <style>{`
        @keyframes progress {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(200%); }
        }
      `}</style>
    </div>
  );
};
